import { gql } from '@apollo/client';

export default gql`
  query template($id: ID!) {
    space {
      adminRole
    }
    template(id: $id) {
      id
      name
      periodCycle
      periodNumber
      templateFields {
        id
        name
        order
      }
    }
  }
`;
